/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    ACTIVATE_title: "Activer votre compte",
    ACTIVATE_greeting: "Bonjour {0},",
    ACTIVATE_intro: "Définissez votre mot de passe pour accéder à la Console.",
    ACTIVATE_password: "Mot de passe",
    ACTIVATE_passwordPlaceholder: "Votre mot de passe",
    ACTIVATE_confirmPassword: "Confirmer le mot de passe",
    ACTIVATE_confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    ACTIVATE_submit: "Activer mon compte",
    ACTIVATE_loading: "Chargement…",
    ACTIVATE_mismatch: "Les mots de passe ne correspondent pas.",
    ACTIVATE_invalid: "Cette invitation est invalide ou a déjà été utilisée.",
    ACTIVATE_success: "Compte activé",
    ACTIVATE_successMessage: "Votre compte est activé. Vous pouvez maintenant vous connecter.",
    ACTIVATE_goToSignIn: "Se connecter",

    PASSWORD_RULE_length: "Entre 9 et 30 caractères",
    PASSWORD_RULE_lower: "Une lettre minuscule",
    PASSWORD_RULE_upper: "Une lettre majuscule",
    PASSWORD_RULE_digit: "Un chiffre"
};
